import { resolvedLanguage } from '@/i18n.ts';
import {
  API_URL,
  DEFAULT_CKEY,
  getInitializedMomentFetcher,
} from '@moment/net/fetch-contstants.ts';
import { IDailyLookBookResponce } from '@pages/Root/services/api/lookBook/interfaces.ts';

export const GAMES_QUERY_KEY = 'playable'

export const fetchGames = (params?: { lang?: string }) => async () => {
  const language = params?.lang || resolvedLanguage('en');
  const momentFetcher = await getInitializedMomentFetcher()
  const schedule = 'html5games';
  const url = `${API_URL}/wp/v1/daily?ckey=${DEFAULT_CKEY}&sched=${schedule}&mp_lang=${language}&previewAspect=all`;
  const rawResponse = await momentFetcher.fetch(url);
  const response = (await rawResponse.json()) as IDailyLookBookResponce;
  return response;
};
